"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.useKeyboardEvents = void 0;
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _react = require("react");
var _map = require("../../../lib/map.utils");
/**
 * Hook to manage keyboard event handlers for map markers.
 * Provides accessibility support for keyboard navigation with proper state management.
 *
 * @param {Object} params - The parameters object
 * @param {Function} params.onMarkerClick - Callback function triggered when a marker is clicked
 * @param {boolean} params.enableAdvancedMarkers - Flag to enable advanced marker functionality
 * @param {Set} params.enabledLocationIds - Set of location IDs that are enabled
 * @param {Object} params.gMaps - Google Maps API object
 * @param {Object} params.theme - Theme configuration object for marker styling
 * @param {string} params.defaultMarkerIcon - Default icon configuration for markers
 * @param {React.MutableRefObject} params.markersRef - Ref object containing all marker instances
 *
 * @returns {Object} Object containing keyboard event handlers
 * @returns {Function} returns.focus - Handler for when marker receives keyboard focus
 * @returns {Function} returns.blur - Handler for when marker loses keyboard focus
 * @returns {Function} returns.keydown - Handler for keydown events (Enter/Space)
 * @returns {Function} returns.keyup - Handler for keyup events
 */
const useKeyboardEvents = _ref => {
  let {
    onMarkerClick,
    enableAdvancedMarkers,
    enabledLocationIds,
    gMaps,
    theme,
    defaultMarkerIcon,
    markersRef
  } = _ref;
  const handleFocus = (0, _react.useCallback)(_ref2 => {
    let {
      marker,
      meta
    } = _ref2;
    if (!enableAdvancedMarkers || !enabledLocationIds.has(meta.location.id)) {
      return;
    }
    meta.isHovered = true;
    (0, _map.setMarkerIcon)(meta, marker, gMaps, theme, defaultMarkerIcon, enableAdvancedMarkers);
  }, [enableAdvancedMarkers, enabledLocationIds, gMaps, theme, defaultMarkerIcon]);
  const handleBlur = (0, _react.useCallback)(_ref3 => {
    let {
      marker,
      meta
    } = _ref3;
    if (!enableAdvancedMarkers) {
      return;
    }
    meta.isHovered = false;
    (0, _map.setMarkerIcon)(meta, marker, gMaps, theme, defaultMarkerIcon, enableAdvancedMarkers);
  }, [enableAdvancedMarkers, gMaps, theme, defaultMarkerIcon]);
  const handleKeyDown = (0, _react.useCallback)(_ref4 => {
    let {
      marker,
      meta,
      event
    } = _ref4;
    if (!enableAdvancedMarkers || !enabledLocationIds.has(meta.location.id)) {
      return;
    }
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      meta.isPressed = true;
      (0, _map.setMarkerIcon)(meta, marker, gMaps, theme, defaultMarkerIcon, enableAdvancedMarkers);
    }
  }, [enableAdvancedMarkers, enabledLocationIds, gMaps, theme, defaultMarkerIcon]);
  const handleKeyUp = (0, _react.useCallback)(_ref5 => {
    let {
      marker,
      meta,
      event
    } = _ref5;
    if (!enableAdvancedMarkers || !enabledLocationIds.has(meta.location.id)) {
      return;
    }
    if (event.key === 'Enter' || event.key === ' ') {
      var _context, _context2;
      event.preventDefault();

      // Clear all previously pressed markers
      const previouslyClickedMarker = ((_context = markersRef.current) == null ? void 0 : (0, _bind.default)(_context2 = Function.call).call(_context2, (0, _filter.default)(_context), _context))?.(_ref6 => {
        let {
          meta
        } = _ref6;
        return meta.isPressed;
      }) || [];
      if (previouslyClickedMarker.length > 0) {
        (0, _forEach.default)(previouslyClickedMarker).call(previouslyClickedMarker, _ref7 => {
          let {
            marker,
            meta
          } = _ref7;
          meta.isPressed = false;
          (0, _map.setMarkerIcon)(meta, marker, gMaps, theme, defaultMarkerIcon, enableAdvancedMarkers);
        });
      }

      // Set pressed state and trigger click callback
      meta.isKeyboardFocused = false;
      meta.isPressed = true;
      (0, _map.setMarkerIcon)(meta, marker, gMaps, theme, defaultMarkerIcon, enableAdvancedMarkers);
      onMarkerClick({
        marker,
        meta
      });
    }
  }, [enableAdvancedMarkers, enabledLocationIds, gMaps, theme, defaultMarkerIcon, markersRef, onMarkerClick]);
  return {
    focus: handleFocus,
    blur: handleBlur,
    keydown: handleKeyDown,
    keyup: handleKeyUp
  };
};
exports.useKeyboardEvents = useKeyboardEvents;